import { TableCell, TableRow, Typography } from "@mui/material";
import moment from "moment";
import React from "react";
import TableActions from "src/common/TableActions";
import { useApiMutation } from "src/hooks/useApiMutation";
import { getStatusLabelInvoiceStatus } from "src/Utils/Combined";
import type { B2B_Invoice_list } from "../type/b2bType";

interface Props {
	invoice: B2B_Invoice_list;
	index: number;
	paginationSkip: number;
}

const B2BInvoiceTableRow: React.FC<Props> = ({
	invoice,
	index,
	paginationSkip,
}) => {
	const { mutate: deleteInvoice, isPending: isDeletePending } = useApiMutation<
		void,
		void
	>({
		method: "DELETE",
		endPoint: `/api/admin/b2b/invoice/${invoice.id}`,
		invalidateQueries: ["b2b_invoice"],
	});

	return (
		<TableRow hover>
			<TableCell>
				<Typography variant="body1" color="text.primary" gutterBottom noWrap>
					{index + 1 + Number(paginationSkip)}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="body1" color="text.primary" gutterBottom noWrap>
					{invoice?.invoice_date
						? moment(invoice.invoice_date).format("LL")
						: "-"}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="body1" color="text.primary" gutterBottom noWrap>
					{invoice?.invoice_no || "-"}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="body1" color="text.primary" gutterBottom noWrap>
					{invoice?.b2b_organization || "N/A"}
					{invoice?.b2b_first_name
						? ` (${invoice.b2b_first_name} ${invoice.b2b_last_name || ""})`
						: ""}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="body1" color="text.primary" gutterBottom noWrap>
					{invoice?.b2b_phone || "-"}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="body1" color="text.primary" gutterBottom noWrap>
					{Number(invoice?.net_total || 0).toLocaleString()}
				</Typography>
			</TableCell>
			<TableCell>
				{getStatusLabelInvoiceStatus(invoice?.status)}
			</TableCell>
			<TableActions
				showView
				viewLink={`/b2b/b2b-invoice/${invoice?.id}`}
				showDelete
				handleDeleteFun={() => deleteInvoice()}
				loading={isDeletePending}
			/>
		</TableRow>
	);
};

export default B2BInvoiceTableRow;
